import React from 'react';
import { Divider, Flex, SideNavItem, Text } from '@amzn/storm-ui';
import { GroupLinksWrapper } from './styles';
import { PivotNavGroup } from 'src/app/slice';
import { getCommonPivotItemProps } from './util';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';

export const PivotGroup: React.VFC<PivotNavGroup> = ({
  links,
  label,
  selectedItemId,
  isLastGroup,
}) => {
  return (
    <>
      {!!label && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          padding="xxsmall"
        >
          <Text renderAs="span" weight="bold">
            {label}
          </Text>
        </Flex>
      )}
      <GroupLinksWrapper hasLabel={!!label}>
        {links.map((link) => {
          const itemProps = {
            ...getCommonPivotItemProps(link),
            ...(link.id === selectedItemId && {
              isActive: true,
              'aria-current': 'page' as const,
            }),
            ...(!!link.flag && {
              renderEnd: () => <LaunchFlag flag={link.flag} />,
            }),
            tooltip: link?.toolTip,
          };

          return (
            <SideNavItem {...itemProps} key={link.label}>
              {link.label}
            </SideNavItem>
          );
        })}
      </GroupLinksWrapper>
      {!isLastGroup && <Divider />}
    </>
  );
};
